export const styleConstants = {
  headerHeight: '5.5em',
};
